import React from "react"
import { Helmet } from "react-helmet-async"
import BreadCrumbs from "../components/BreadCrumbs"
import ComingSoon from "../components/ComingSoon"
import {
    signUpClickHandler,
    comingSoonClickHandler,
} from "../utilities/helpers"

export default function Pricing() {
    const crumbs = [
        {
            path: "/",
            name: "Chaperon",
        },
        {
            path: "/pricing",
            name: "Pricing",
        },
    ]

    return (
        <div>
            <Helmet>
                <meta charSet="utf-8" />
                <title>Chaperon - Pricing Plans</title>
                <meta
                    name="description"
                    content="Choose the right Chaperon plan for your safety needs."
                />
            </Helmet>

            <BreadCrumbs crumbs={crumbs} />
            <ComingSoon />

            <div className="container py-5">
                <div className="text-center mb-5">
                    <h1 className="display-4 fw-bold">Safety Plans for All</h1>
                    <p className="lead text-muted">
                        Choose the plan that's right for you and the people you
                        care about.
                    </p>
                </div>

                <div className="row row-cols-1 row-cols-md-3 g-4 mb-5">
                    {/* Basic Plan */}
                    <div className="col">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body">
                                <h2 className="card-title">Core</h2>
                                <p className="text-muted">
                                    Ideal for your own personal solo needs
                                </p>
                                <div className="py-3">
                                    <h3 className="card-text display-5">
                                        $9.99
                                    </h3>
                                    <p className="text-muted">per month</p>
                                </div>
                                <ul className="list-unstyled text-start">
                                    <li className="py-2">
                                        ✓ Automatic location monitoring
                                    </li>
                                    <li className="py-2">
                                        ✓ Real-time safety monitoring
                                    </li>
                                    <li className="py-2">
                                        ✓ Advanced risk assessment
                                    </li>
                                    <li className="py-2">
                                        ✓ Unlimited safety profiling
                                    </li>
                                    <li className="py-2">✓ Alerts</li>
                                </ul>
                            </div>
                            <div className="card-footer bg-transparent border-0 pb-4">
                                <button
                                    className="btn btn-outline-danger w-100"
                                    onClick={comingSoonClickHandler}
                                >
                                    Start Free Trial
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Standard Plan */}
                    <div className="col">
                        <div className="card h-100 shadow border border-danger">
                            <div className="card-header bg-danger text-white text-center py-3">
                                <span className="badge bg-white text-danger">
                                    MOST POPULAR
                                </span>
                            </div>
                            <div className="card-body">
                                <h2 className="card-title">Clique</h2>
                                <p className="text-muted">
                                    Perfect for families and small groups
                                </p>
                                <div className="py-3">
                                    <h3 className="card-text display-5">
                                        $12.99
                                    </h3>
                                    <p className="text-muted">per month</p>
                                </div>
                                <ul className="list-unstyled text-start">
                                    <li className="py-2">
                                        ✓ Everything in the <b>Core</b> plan
                                    </li>
                                    <li className="py-2">
                                        ✓ <b>Community</b> feature (up to 3
                                        members)
                                    </li>
                                    <li className="py-2">
                                        ✓ <b>Checker</b> feature (up to 3
                                        members)
                                    </li>
                                    <li className="py-2">✓ Safety dashboard</li>
                                    <li className="py-2">✓ Mobile alerts</li>
                                </ul>
                            </div>
                            <div className="card-footer bg-transparent border-0 pb-4">
                                <button
                                    className="btn btn-danger w-100"
                                    onClick={comingSoonClickHandler}
                                >
                                    Start Free Trial
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Premium Plan */}
                    <div className="col">
                        <div className="card h-100 shadow-sm">
                            <div className="card-body">
                                <h2 className="card-title">Crew</h2>
                                <p className="text-muted">
                                    Great for frequent travelers & remote teams
                                </p>
                                <div className="py-3">
                                    <h3 className="card-text display-5">
                                        $19.99
                                    </h3>
                                    <p className="text-muted">per month</p>
                                </div>
                                <ul className="list-unstyled text-start">
                                    <li className="py-2">
                                        ✓ All features in the <b>Clique</b> plan
                                    </li>
                                    <li className="py-2">
                                        ✓ <b>Community</b> feature (up to 10
                                        members)
                                    </li>
                                    <li className="py-2">
                                        ✓ <b>Checker</b> feature (up to 5
                                        members)
                                    </li>
                                    <li className="py-2">
                                        ✓ Team safety dashboard
                                    </li>
                                    <li className="py-2">
                                        ✓ Emergency support
                                    </li>
                                </ul>
                            </div>
                            <div className="card-footer bg-transparent border-0 pb-4">
                                <button
                                    className="btn btn-outline-danger w-100"
                                    onClick={comingSoonClickHandler}
                                >
                                    Start Free Trial
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Enterprise Section */}
                <div className="row my-5">
                    <div className="col-lg-8 mx-auto">
                        <div className="card shadow-lg">
                            <div className="card-body p-5">
                                <div className="row">
                                    <div className="col-md-8">
                                        <h2>Corporation</h2>
                                        <p className="lead">
                                            Solutions for large teams and
                                            enterprises
                                        </p>
                                        <ul className="list-unstyled text-start">
                                            <li className="py-2">
                                                ✓ Personal safety consultant
                                            </li>
                                            <li className="py-1">
                                                ✓ Dedicated account manager
                                            </li>
                                            <li className="py-1">
                                                ✓ Emergency assistance hotline
                                            </li>
                                            <li className="py-1">
                                                ✓ API access for integration
                                            </li>
                                            <li className="py-1">
                                                ✓ Reports and analytics
                                            </li>
                                        </ul>
                                    </div>
                                    <div className="col-md-4 d-flex align-items-center">
                                        <button
                                            className="btn btn-outline-danger btn-lg w-100"
                                            onClick={signUpClickHandler}
                                        >
                                            Contact Sales
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* FAQ Section */}
                <div className="row mt-5 pt-5">
                    <div className="col-12 text-center mb-4">
                        <h2>Frequently Asked Questions</h2>
                    </div>
                    <div className="col-lg-8 mx-auto">
                        <div className="accordion" id="pricingFAQ">
                            <div className="accordion-item">
                                <h3 className="accordion-header">
                                    <button
                                        className="accordion-button"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseOne"
                                    >
                                        Can I try Chaperon before purchasing?
                                    </button>
                                </h3>
                                <div
                                    id="collapseOne"
                                    className="accordion-collapse collapse show"
                                    data-bs-parent="#pricingFAQ"
                                >
                                    <div className="accordion-body">
                                        Yes! All plans come with a 14-day free
                                        trial. No credit card required to start.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h3 className="accordion-header">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseTwo"
                                    >
                                        Can I change plans later?
                                    </button>
                                </h3>
                                <div
                                    id="collapseTwo"
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#pricingFAQ"
                                >
                                    <div className="accordion-body">
                                        Absolutely! You can upgrade or downgrade
                                        your plan at any time. Changes take
                                        effect at the start of your next billing
                                        cycle.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h3 className="accordion-header">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseThree"
                                    >
                                        How does family sharing work?
                                    </button>
                                </h3>
                                <div
                                    id="collapseThree"
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#pricingFAQ"
                                >
                                    <div className="accordion-body">
                                        Family sharing allows you to extend your
                                        Chaperon protection to family members.
                                        They'll receive their own login
                                        credentials but will be managed under
                                        your account.
                                    </div>
                                </div>
                            </div>
                            <div className="accordion-item">
                                <h3 className="accordion-header">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target="#collapseFour"
                                    >
                                        What payment methods do you accept?
                                    </button>
                                </h3>
                                <div
                                    id="collapseFour"
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#pricingFAQ"
                                >
                                    <div className="accordion-body">
                                        We accept all major credit cards,
                                        PayPal, and Apple Pay. Enterprise
                                        customers can arrange for invoice-based
                                        payment.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
